/* Quick add on a WHF product card.
 *
 * Two steps on purpose. The strip along the foot of the card says what will
 * happen; tapping it turns that same strip into the product's sizes, so the
 * control becomes the answer rather than throwing a modal over the grid. A
 * single-variant product skips straight to the add.
 *
 * The card renders no <form>: the card root is a link, and a form inside one
 * would submit and navigate. Everything here posts to /cart/add directly and
 * then hands the response to the cart drawer, in the same order product-form.js
 * uses.
 */
(function () {
  /* Run once per page. whf-product-grid.liquid emits this <script> per
     section, and a page with two grids ran the click handler twice: the
     first opened the size tray and the second closed it in the same tick,
     so quick add looked dead the moment the home page gained a second
     grid (11 Oct 2026). Browsers execute duplicate deferred scripts once
     per tag, so the guard has to live here. */
  if (window.__whfQuickAddBound) return;
  window.__whfQuickAddBound = true;
  var OPEN = 'is-open';
  var BUSY = 'is-busy';
  /* On touch the control rests as a square in the card's corner. A message
     has no room there, so saying anything widens the box back to the full
     card — see the (hover: none) block in whf-product-card.css. */
  var NOTED = 'is-noted';

  function strings() {
    var s = window.whfQuickAddStrings || {};
    return {
      added: s.added || 'Added',
      failed: s.failed || 'Could not add that.'
    };
  }

  function cartEl() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function trayOf(qa) {
    return qa.querySelector('[data-whf-qa-tray]');
  }

  function close(qa) {
    var tray = trayOf(qa);
    if (tray) tray.hidden = true;
    var toggle = qa.querySelector('[data-whf-qa-toggle]');
    if (toggle) {
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');
    }
    qa.classList.remove(OPEN);
    note(qa, '');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-whf-qa].' + OPEN).forEach(function (qa) {
      if (qa !== except) close(qa);
    });
  }

  function open(qa) {
    closeAll(qa);
    var tray = trayOf(qa);
    if (!tray) return;
    tray.hidden = false;
    var toggle = qa.querySelector('[data-whf-qa-toggle]');
    if (toggle) {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
    }
    qa.classList.add(OPEN);
    var first = tray.querySelector('[data-whf-qa-size]:not([disabled])');
    if (first) first.focus();
  }

  /* Errors belong on the card that produced them. The live region carries the
   * same words for a screen reader. */
  function note(qa, text) {
    var el = qa.querySelector('.whf-card__qa-note');
    if (!text) {
      if (el) el.remove();
      qa.classList.remove(NOTED);
      return;
    }
    if (!el) {
      el = document.createElement('span');
      el.className = 'whf-card__qa-note';
      qa.appendChild(el);
    }
    el.textContent = text;
    qa.classList.add(NOTED);
  }

  function announce(qa, text) {
    var status = qa.querySelector('.whf-card__qa-status');
    if (status) status.textContent = text;
  }

  function add(qa, variantId, source) {
    if (!variantId || qa.classList.contains(BUSY)) return;

    var cart = cartEl();
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }
          };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    config.body = JSON.stringify(body);

    qa.classList.add(BUSY);
    note(qa, '');

    fetch(window.routes ? routes.cart_add_url : '/cart/add', config)
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          note(qa, response.description || response.message || strings().failed);
          announce(qa, strings().failed);
          return;
        }

        if (source) source.classList.add('is-added');
        announce(qa, strings().added);
        window.setTimeout(function () {
          if (source) source.classList.remove('is-added');
          close(qa);
        }, 900);

        /* The drawer's focus trap targets .drawer__inner-empty, which
         * renderContents removes. Drop is-empty first or trapFocus() throws on
         * a null container. Straight from product-form.js. */
        if (cart && cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
        /* Publish BEFORE renderContents, the same order product-form.js uses:
         * renderContents replaces #CartDrawer, and the fresh
         * <cart-drawer-items> subscribes to cartUpdate. Publishing after would
         * make it refetch /cart and overwrite the markup just rendered. */
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'whf-quick-add',
            productVariantId: String(variantId),
            cartData: response
          });
        }
        if (cart && cart.renderContents) {
          cart.renderContents(response);
        } else {
          window.location = window.routes ? routes.cart_url : '/cart';
        }
      })
      .catch(function (e) {
        console.error(e);
        note(qa, strings().failed);
        announce(qa, strings().failed);
      })
      .finally(function () {
        qa.classList.remove(BUSY);
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var toggle = event.target.closest('[data-whf-qa-toggle]');
    if (toggle) {
      var qaT = toggle.closest('[data-whf-qa]');
      if (qaT) {
        qaT.classList.contains(OPEN) ? close(qaT) : open(qaT);
      }
      return;
    }

    var closer = event.target.closest('[data-whf-qa-close]');
    if (closer) {
      var qaC = closer.closest('[data-whf-qa]');
      if (qaC) close(qaC);
      return;
    }

    var chip = event.target.closest('[data-whf-qa-size]');
    if (chip && !chip.disabled) {
      var qaS = chip.closest('[data-whf-qa]');
      if (qaS) add(qaS, chip.dataset.variantId, chip);
      return;
    }

    var direct = event.target.closest('[data-whf-qa-add]');
    if (direct) {
      var qaD = direct.closest('[data-whf-qa]');
      if (qaD) add(qaD, direct.dataset.variantId, direct);
      return;
    }

    /* A tap anywhere else, including on another card, puts the open tray away
     * rather than leaving sizes stranded over the grid. */
    closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var qa = document.querySelector('[data-whf-qa].' + OPEN);
    if (!qa) return;
    var toggle = qa.querySelector('[data-whf-qa-toggle]');
    close(qa);
    if (toggle) toggle.focus();
  });
})();
